<template>
  <div class="tech-share">
    <div class="container">
      <div class="sidebar">
        <div class="search-box">
          <input type="text" placeholder="搜索技术分享..." class="search-input" v-model="searchQuery">
          <button class="search-btn" @click="handleSearch">搜索</button>
        </div>
        <div class="category-list">
          <h3>技术分类</h3>
          <ul>
            <li class="category-item" :class="{ active: selectedCategory === '全部' }" @click="selectCategory('全部')">全部</li>
            <li class="category-item" :class="{ active: selectedCategory === '交易策略' }" @click="selectCategory('交易策略')">交易策略</li>
            <li class="category-item" :class="{ active: selectedCategory === '技术分析' }" @click="selectCategory('技术分析')">技术分析</li>
            <li class="category-item" :class="{ active: selectedCategory === '指标编写' }" @click="selectCategory('指标编写')">指标编写</li>
            <li class="category-item" :class="{ active: selectedCategory === '软件使用' }" @click="selectCategory('软件使用')">软件使用</li>
          </ul>
        </div>
      </div>
      <div class="content">
        <div class="page-header">
          <h1>技术分享</h1>
          <p>分享交易技巧，交流投资心得</p>
        </div>
        <div class="post-list">
          <div class="post-item" v-for="post in filteredPosts" :key="post.id">
            <div class="post-header">
              <h2 class="post-title"><router-link :to="{ name: 'post', params: { id: post.id } }" class="post-link">{{ post.title }}</router-link></h2>
              <span class="post-tag">{{ post.tag }}</span>
            </div>
            <div class="post-content">
              {{ post.content }}
            </div>
            <div class="post-meta">
              <span class="post-time">{{ post.time }}</span>
              <span class="post-views">{{ post.views }}</span>
            </div>
          </div>
        </div>
        <div class="pagination">
          <button class="page-btn">上一页</button>
          <button class="page-btn active">1</button>
          <button class="page-btn">2</button>
          <button class="page-btn">3</button>
          <button class="page-btn">下一页</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TechShareView',
  data() {
    return {
      searchQuery: '',
      selectedCategory: '全部',
      posts: [
        {
          id: 6,
          title: '【技术分享】如何构建属于自己的交易系统',
          tag: '交易策略',
          content: '交易系统是交易者的核心竞争力，本文章详细介绍如何构建一个适合自己的交易系统，包括入场信号、出场策略、资金管理等方面...',
          time: '3天前',
          views: '128'
        },
        {
          id: 7,
          title: '【实战教程】通达信指标编写入门到精通',
          tag: '指标编写',
          content: '从基础语法到高级技巧，全面讲解通达信指标的编写方法，帮助你快速掌握指标编写技能，打造属于自己的交易工具...',
          time: '1周前',
          views: '256'
        },
        {
          id: 8,
          title: '【技术分析】MACD指标的深度解析与实战应用',
          tag: '技术分析',
          content: 'MACD是最常用的技术指标之一，本文深入解析MACD的原理和应用技巧，结合实际案例说明如何利用MACD捕捉买卖点...',
          time: '2周前',
          views: '189'
        },
        {
          id: 9,
          title: '【软件使用】通达信软件高级功能使用技巧',
          tag: '软件使用',
          content: '通达信软件有很多实用的高级功能，本文详细介绍这些功能的使用方法，帮助你提高看盘和交易效率...',
          time: '3周前',
          views: '145'
        },
        {
          id: 10,
          title: '【交易心理】如何克服交易中的恐惧和贪婪',
          tag: '交易策略',
          content: '交易心理是决定交易成败的关键因素，本文分享如何克服交易中的恐惧和贪婪，保持良好的交易心态...',
          time: '1个月前',
          views: '203'
        }
      ]
    }
  },
  computed: {
    filteredPosts() {
      let result = [...this.posts];
      
      // 分类筛选
      if (this.selectedCategory !== '全部') {
        result = result.filter(post => post.tag === this.selectedCategory);
      }
      
      // 搜索筛选
      if (this.searchQuery) {
        const query = this.searchQuery.toLowerCase();
        result = result.filter(post => 
          post.title.toLowerCase().includes(query) || 
          post.content.toLowerCase().includes(query)
        );
      }
      
      return result;
    }
  },
  methods: {
    selectCategory(category) {
      this.selectedCategory = category;
    },
    handleSearch() {
      // 搜索逻辑已在computed中处理
    }
  }
}
</script>

<style lang="scss" scoped>
.tech-share {
  padding: 20px 0;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  gap: 30px;
}

.sidebar {
  width: 250px;
  flex-shrink: 0;
}

.search-box {
  display: flex;
  margin-bottom: 30px;
  .search-input {
    flex: 1;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 4px 0 0 4px;
    outline: none;
    &:focus {
      border-color: #1890ff;
    }
  }
  .search-btn {
    padding: 0 15px;
    background-color: #1890ff;
    color: #fff;
    border: none;
    border-radius: 0 4px 4px 0;
    cursor: pointer;
    &:hover {
      background-color: #40a9ff;
    }
  }
}

.category-list {
  h3 {
    font-size: 18px;
    margin-bottom: 15px;
    color: #333;
  }
  ul {
    list-style: none;
  }
  .category-item {
    padding: 10px 15px;
    margin-bottom: 5px;
    background-color: #f5f5f5;
    border-radius: 4px;
    cursor: pointer;
    &:hover {
      background-color: #e6f7ff;
    }
    &.active {
      background-color: #1890ff;
      color: #fff;
    }
  }
}

.content {
  flex: 1;
}

.page-header {
  margin-bottom: 30px;
  h1 {
    font-size: 28px;
    font-weight: 600;
    color: #333;
    margin-bottom: 10px;
  }
  p {
    font-size: 16px;
    color: #666;
  }
}

.post-list {
  margin-bottom: 30px;
}

.post-item {
  background-color: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
}

.post-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 15px;
}

.post-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  flex: 1;
  margin-right: 15px;
  line-height: 1.4;
  .post-link {
    color: #333;
    text-decoration: none;
    &:hover {
      color: #1890ff;
      text-decoration: underline;
    }
  }
}

.post-tag {
  padding: 4px 12px;
  background-color: #f0f0f0;
  border-radius: 12px;
  font-size: 12px;
  color: #666;
  white-space: nowrap;
}

.post-content {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.post-meta {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #999;
}

.pagination {
  display: flex;
  justify-content: center;
  gap: 10px;
}

.page-btn {
  padding: 8px 16px;
  border: 1px solid #e8e8e8;
  background-color: #fff;
  border-radius: 4px;
  cursor: pointer;
  &:hover {
    border-color: #1890ff;
    color: #1890ff;
  }
  &.active {
    background-color: #1890ff;
    color: #fff;
    border-color: #1890ff;
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .container {
    flex-direction: column;
    gap: 20px;
  }
  
  .sidebar {
    width: 100%;
  }
  
  .search-box {
    margin-bottom: 20px;
  }
  
  .category-list {
    h3 {
      font-size: 16px;
      margin-bottom: 10px;
    }
    ul {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
    }
    .category-item {
      margin-bottom: 0;
      white-space: nowrap;
    }
  }
  
  .page-header {
    h1 {
      font-size: 24px;
    }
    p {
      font-size: 14px;
    }
  }
  
  .post-item {
    padding: 15px;
    margin-bottom: 15px;
  }
  
  .post-title {
    font-size: 16px;
  }
  
  .post-content {
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .tech-share {
    padding: 10px 0;
  }
  
  .post-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  
  .post-tag {
    align-self: flex-start;
  }
  
  .page-btn {
    padding: 6px 12px;
    font-size: 14px;
  }
}
</style>